import { useEffect, useRef, useState } from "react";
import { loadingsShow } from "../../Services/PostAPI";
import invoicesData from "./tableData.json";
import { APP_URLS } from "../../constants/urlConstants";
import { useHistory } from "react-router-dom";
import { generatePath } from "react-router-dom/cjs/react-router-dom.min";
import Invoices from "../../components/Invoices";
import { connect } from "react-redux";
import {
  initializeInvoiceScreen,
  fetchInvoice,
  downloadInvoice,
  sendInvoiceEmail,
  sendMultipleInvoices,
  generateInvoice,
} from "../../Redux/Actions/invoice";
import DownloadModal from "../../common/DownloadModal";
import GenerateInvoiceModal from "../../common/GenerateInvoiceModal";
import { EzToast, TOAST_SEVERITY } from "../../common/EzToast";
import { Toast } from "primereact/toast";
import { ProgressBar } from "primereact/progressbar";
import { getToastProps } from "../../utils/common";
import { createLabelValueObj } from "../../common/ContextMenu/utils";
import EzDialog from "../../common/EzDialog";
import CreateInvoicePaymentScreen from "./InvoicePayment/CreateInvoicePayment";

const OpenAssetDialog = "OpenAssetDialog";

const InvoicesScreen = (props) => {
  const {
    fetchInvoice,
    downloadInvoice,
    history,
    initializeInvoiceScreen,
    showPageLevelLoader,
    invoiceListView,
    paginationInfo,
    isLoading,
    screenPermissions,
    isDownloadSuccess,
    isDownloadError,
    sendInvoiceEmail,
    isEmailSuccess,
    isEmailError,
    sendMultipleInvoices,
    isSendMultipleSuccess,
    isSendMultipleError,
    generateInvoice,
    isGenerateInvoiceSuccess,
    isGenerateInvoiceError,
  } = props;
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [fileType, setFileType] = useState("PDF");
  const [selectedRow, setSelectedRow] = useState(null);
  const toast = useRef(null);
  const [showdialog, setShowDialog] = useState(false);
  const [selectedInvoiceRecord, setSelectedInvoiceRecord] = useState(null);
  const [showGenerateModal, setShowGenerateModal] = useState(false);

  const closeModal = () => setIsModalVisible(false);

  useEffect(() => {
    initializeInvoiceScreen();
    fetchInvoice();
  }, []);

  const createInvoice = () => history.push(APP_URLS.INVOICES.ADD_INVOICES);

  const handleGenerateInvoiceSubmit = (payload) => {
    generateInvoice(payload);
  };

  const handleGenerateBulkSubmit = (payload) => {
    generateInvoice(payload, true);
  };

  const editInvoice = ({ invoice_number }) => {
    history.push(
      generatePath(APP_URLS.INVOICES.EDIT_INVOICES, { id: invoice_number })
    );
  };

  const readInvoice = ({ invoice_number }) => {
    history.push(
      generatePath(APP_URLS.INVOICES.VIEW_INVOICES, { id: invoice_number })
    );
  };

  const handlePayment = () => {
    history.push(APP_URLS.INVOICES.PAYMENT_LIST);
  };

  const emailInvoice = ({ id }) => {
    sendInvoiceEmail(id);
  };

  const handleSendMultipleInvoices = (selectedRecords) => {
    if (!selectedRecords || selectedRecords.length === 0) {
      if (toast.current) {
        toast.current.show({
          severity: "warn",
          summary: "Warning",
          detail: "Please select at least one invoice to send.",
          life: 3000,
        });
      }
      return;
    }
    const ids = selectedRecords.map((r) => r.id);
    sendMultipleInvoices(ids);
  };

  const handleExport = () => {
    if (selectedRow && selectedRow.invoice_number) {
      const payload = {
        invoiceNumber: selectedRow.invoice_number,
        fileType: fileType,
      };
      downloadInvoice(payload);
    } else {
      if (toast.current) {
        toast.current.show({
          severity: "warn",
          summary: "Warning",
          detail: "Please select an invoice to export.",
          life: 3000,
        });
      }
    }
    closeModal();
  };

  const downloadInvoiceModelOpen = (rowData) => {
    setSelectedRow(rowData);
    setIsModalVisible(true);
  };

  const loadLazyData = (props) => {
    fetchInvoice(props);
  };

  const onHide = () => {
    setShowDialog(false);
    history.push(APP_URLS.INVOICES.HOME);
  };

  const moreActionProps = {
    // isMoreActionDisabled: !screenPermissions?.create,
    isMoreActionDisabled: true,
    downloadEnabled: false,
    moreActionOptions: [
      createLabelValueObj("Payment Offline", OpenAssetDialog),
    ],
    onMoreActionChange: (optionValue, currentRowData) => {
      if (optionValue === OpenAssetDialog) {
        setShowDialog(true);
        setSelectedInvoiceRecord(currentRowData);
      }
    },
  };

  const invoicesProps = {
    createInvoice,
    editInvoice,
    emailInvoice,
    readInvoice,
    downloadInvoiceModelOpen,
    screenPermissions,
    handlePayment,
    fetchInvoices: loadLazyData,
    handleSendMultipleInvoices,
    onGenerateInvoices: () => setShowGenerateModal(true),
    ...invoicesData,
    tableData: {
      ...invoicesData.tableData,
      rows: invoiceListView,
    },
    paginationInfo: {
      ...invoicesData.paginationInfo,
      pageSize: paginationInfo?.pageSize,
      pageNumber: paginationInfo?.pageNumber,
      totalPages: paginationInfo?.totalPages,
      totalRecords: paginationInfo?.total_elements,
    },
    isLoading,
    moreActionProps,
  };

  const header = () => <div> Add Payment </div>;

  const renderProgressBar = () => {
    return <ProgressBar mode="indeterminate" style={{ height: "6px" }} />;
  };

  if (showPageLevelLoader) {
    loadingsShow("block");
    return null;
  }
  loadingsShow("none");

  return (
    <div>
      {isLoading && renderProgressBar()}
      <EzToast
        {...getToastProps(
          isDownloadSuccess,
          isDownloadError,
          `Invoice Download ${fileType} Successfully`,
          `Error while Downloading ${fileType} Invoice`
        )}
      />
      <EzToast
        {...getToastProps(
          isEmailSuccess,
          isEmailError,
          "Invoice emailed successfully!",
          "Error while sending invoice email."
        )}
      />
      <EzToast
        {...getToastProps(
          isSendMultipleSuccess,
          isSendMultipleError,
          "Bulk Invoice Background Job Submitted, Please check your email for the updates",
          "Error while sending invoices."
        )}
      />
      <EzToast
        {...getToastProps(
          isGenerateInvoiceSuccess,
          isGenerateInvoiceError,
          "Invoices generated successfully!",
          "Error while generating invoices."
        )}
      />
      <Toast ref={toast} />
      <Invoices {...invoicesProps} />
      <GenerateInvoiceModal
        visible={showGenerateModal}
        onHide={() => setShowGenerateModal(false)}
        onSubmit={handleGenerateInvoiceSubmit}
        onSubmitBulk={handleGenerateBulkSubmit}
      />
      <DownloadModal
        visible={isModalVisible}
        onExport={handleExport}
        onHide={closeModal}
        fileType={fileType}
        setFileType={setFileType}
      />
      {showdialog && (
        <EzDialog
          header={header}
          width={"50vw"}
          onHide={onHide}
          onShow={initializeInvoiceScreen}
        >
          <CreateInvoicePaymentScreen
            closeDialog={onHide}
            selectedInvoiceRecord={selectedInvoiceRecord}
          />
        </EzDialog>
      )}
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    initializeInvoiceScreen: () => dispatch(initializeInvoiceScreen()),
    fetchInvoice: (payload) => dispatch(fetchInvoice(payload)),
    downloadInvoice: (payload) => dispatch(downloadInvoice(payload)),
    sendInvoiceEmail: (payload) => dispatch(sendInvoiceEmail(payload)),
    sendMultipleInvoices: (ids) => dispatch(sendMultipleInvoices(ids)),
    generateInvoice: (payload, isBulk) => dispatch(generateInvoice(payload, isBulk)),
  };
};

const mapStateToProps = (state, ownProps) => {
  return {
    ...ownProps,
    isLoading: selectFromInvoicesReducer(state, "isLoading"),
    invoiceListView: selectInvoiceList(state.invoiceReducer),
    showPageLevelLoader: selectIsLoadingPage(state.invoiceReducer),
    paginationInfo: selectPaginationInfo(state.invoiceReducer),
    isPageLevelError: selectIsPageLevelError(state.invoiceReducer),
    isFetchingGridData: selectIsLoading(state.invoiceReducer),
    isDownloadSuccess: selectFromInvoicesReducer(state, "isDownloadSuccess"),
    isDownloadError: selectFromInvoicesReducer(state, "isDownloadError"),
    isEmailSuccess: selectFromInvoicesReducer(state, "isEmailSuccess"),
    isEmailError: selectFromInvoicesReducer(state, "isEmailError"),
    isSendMultipleSuccess: selectFromInvoicesReducer(state, "isSendMultipleSuccess"),
    isSendMultipleError: selectFromInvoicesReducer(state, "isSendMultipleError"),
    isGenerateInvoiceSuccess: selectFromInvoicesReducer(state, "isGenerateInvoiceSuccess"),
    isGenerateInvoiceError: selectFromInvoicesReducer(state, "isGenerateInvoiceError"),
  };
};

const selectInvoiceList = (invoiceReducer) => invoiceReducer.invoiceListView;
const selectIsLoadingPage = (invoiceReducer) => invoiceReducer.isLoadingPage;
const selectPaginationInfo = (invoiceReducer) => invoiceReducer.paginationInfo;
const selectIsPageLevelError = (invoiceReducer) =>
  invoiceReducer.isPageLevelError;
const selectIsLoading = (invoiceReducer) => invoiceReducer.isLoading;

const selectFromInvoicesReducer = (state, path) => {
  return selectInvoicesReducer(state)[path];
};

const selectInvoicesReducer = ({ invoiceReducer }) => {
  return invoiceReducer;
};

export default connect(mapStateToProps, mapDispatchToProps)(InvoicesScreen);
